// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetServiceStatusForSpecialistRequest,
  TGetServiceStatusForSpecialistModel,
  IMappers,
  TGetServiceStatusForSpecialistResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetServiceStatusForSpecialistResponse } from '../../entities/specialist/GetServiceStatusForSpecialistResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetServiceStatusForSpecialistModel(
  parameters: IGetServiceStatusForSpecialistRequest,
): TGetServiceStatusForSpecialistModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'demand',
    pathApi: '/v2/get-service-status-for-specialist/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetServiceStatusForSpecialistOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetServiceStatusForSpecialistRequest;
}

export async function fetchGetServiceStatusForSpecialist<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetServiceStatusForSpecialistOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetServiceStatusForSpecialistResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetServiceStatusForSpecialistModel(parameters),
    config,
  )) as FetchResponse<TGetServiceStatusForSpecialistResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetServiceStatusForSpecialistResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetServiceStatusForSpecialistResponse>;
}
